import { forwardRef, useEffect, useRef, useState } from 'react';
import { grantUpsellNow } from "../../services/pushUpsaleForApp";
import { withUpsellPaypalId } from "../../services/appApi";
import cn from 'classnames';
import { useRegistrationSection } from '../../providers/RegistrationSectionProvider/useRegistrationData';
import styles from './UpsaleCta.module.scss';
import { UpsaleButton } from '../UpsaleButton/UpsaleButton';
import { UpsellConfirm } from '../UpsellConfirm/UpsellConfirm';
import { needsUpsellConfirm, upsellConfirmText } from '../../services/upsellConfirm';
import { Title } from '../Title/Title';
import { useNavigate } from 'react-router';
import { addSubscriptionUpsale } from '../../services/addSubscriptionUpsale';
import { useUserData } from '../../providers/UserDataProvider/useUserData';
import { Spinner } from '../Spinner/Spinner';
import { loadPaypalSdk, loadPaypalSdkForOrder } from '../../services/loadPaypalSdk';
import { getCurrencySymbol } from '../../services/getCurrencySymbol';
import { ampPaypalButtonClicked, ampPurchaseAdditional, ampPurchaseStatus } from '../../utils/AmplitudeEvents';
export const UpsaleCta = forwardRef(({ content: data }, ref) => {
  const { content,nextSlug,sessionInfo } = useRegistrationSection();
  const [message,setMessage] = useState(null);
  const [loading,setLoading] = useState(false);
  const [confirming, setConfirming] = useState(false);
  const { userData,setUserData } = useUserData();
  const currency = localStorage.getItem('currency') || 'usd';
  const [containerID, setContainerID] = useState(null)
  const navigate = useNavigate();

  const paypalRef = useRef(null);
  const subscriptionData = content?.subscriptionData;
  const currencyCode = sessionInfo?.subscription?.currency?.toLowerCase?.() || currency || 'usd';
  const planId = subscriptionData?.planIDPayPal?.[currencyCode] ?? null;
  const currency_code = currencyCode?.toUpperCase() || 'USD';

  useEffect(() => {
    let paypalButtons = null;
    if(!containerID) {
      const randomId = Math.random().toString(36).substring(2, 7);
      setContainerID(`paypal-button-${randomId}`);
      return
    }
    function renderButton() {
      if (window.paypal && planId && paypalRef.current) {
        // Очищаем контейнер
        paypalRef.current.innerHTML = "";
        paypalButtons = window.paypal.Buttons({
          style: {
            shape: 'rect',
            color: 'white',
            layout: 'vertical',
            label: 'paypal',
            tagline: false
          },
          createSubscription: function(data, actions) {
            return actions.subscription.create({
              plan_id: planId
            });
          },
          onApprove: function(data, actions) {
            handleSubmit('paypal', data?.subscriptionID);
            ampPurchaseStatus('UpsaleComplete');
            ampPurchaseAdditional({
              currency: currency_code,
              payment_method: 'PayPal',
              price: subscriptionData.paypalPrice/100 || null,
              productId: planId,
              quantity: 1
            })
          },
          onClick: function () {
            ampPurchaseStatus('UpsaleStarted');
            ampPaypalButtonClicked(subscriptionData.title, data.totalPrice,currency)
          },
          onCancel : function (data, actions) {
            ampPurchaseStatus('UpsaleDecline');
          },
          onError: function (err) {
            const errorMsg = err?.message || String(err);
            console.error('PayPal error:', errorMsg);
            setMessage(errorMsg);
          }
        });
        paypalButtons.render(`#${containerID}`)
      }
    }
    function renderOneTimeButton() {
      if (window.paypalOrder && subscriptionData.paypalPrice && paypalRef.current) {
        // Очищаем контейнер
        paypalRef.current.innerHTML = "";

        paypalButtons = window.paypalOrder.Buttons({
          style: {
            shape: 'rect',
            color: 'white',
            layout: 'vertical',
            label: 'paypal',
            tagline: false
          },
          createOrder: (data, actions) => {
            return actions.order.create({
              purchase_units: [{
                amount: { value: subscriptionData.paypalPrice/100, currency_code: currency_code },
                description: "Lifetime Access"
              }]
            });
          },
          onApprove: (data, actions) => {
            return actions.order.capture().then(details => {
              handleSubmit('paypal', details?.id);
              ampPurchaseStatus('UpsaleComplete');
              ampPurchaseAdditional(
                {
                  currency: currency_code,
                  payment_method: 'PayPal',
                  price: subscriptionData.paypalPrice/100,
                  productId: subscriptionData.paypalPrice/100,
                  quantity: 1
                }
              )
            });
          },
          onClick: function (data, actions) {
            ampPurchaseStatus('UpsaleStarted');
            ampPaypalButtonClicked(subscriptionData.title, data.totalPrice,currency)
          },
          onCancel : function (data, actions) {
            ampPurchaseStatus('UpsaleDecline');
          },
          onError: function (err) {
            const errorMsg = err?.message || String(err);
            console.error('PayPal error:', errorMsg);
            setMessage(errorMsg);
          }
        });
        const delay = Math.floor(Math.random() * (1000 - 500 + 1)) + 500;
        setTimeout(() => {
          paypalButtons.render(`#${containerID}`)
        }, delay);
      }
    }

    if(subscriptionData.type==='subscription'){
      loadPaypalSdk(renderButton);
    }else{
      loadPaypalSdkForOrder(currency_code, 
        renderOneTimeButton
      )
    }

    

    return () => {
      if (paypalButtons) paypalButtons.close();
      if (paypalRef.current) paypalRef.current.innerHTML = "";
    };
  }, [containerID]);

  if (!data || !content || !subscriptionData) {
    return null;
  }
  const { discount, totalPrice, oldPrice,typeTitle, typeText, button, buttonType } = data;
  const { period, type } = subscriptionData;
  const currencySymbol = getCurrencySymbol(currencyCode);
  const handleSubmit = async(type='stripe', paypalId=null) => {

      const {planID,discountID,title,period,course_id} = subscriptionData;
      const {subscription, customer}=sessionInfo;
      setLoading(true);
      const {error } = await addSubscriptionUpsale({
        planID : planID ||null,
        customerID : customer.id || null,
        discountID : discountID || null,
        title : title || null,
        period : period || null,
        discounted : totalPrice,
        subscription : oldPrice,
        currency: subscription.currency || currency || 'usd',
        userEmail: customer.email
      },type);
      setLoading(false);
      if(error){
        console.error(error)
        setMessage(error)
      }else {
        setUserData({
          ...userData,
          upsale:{
            ...userData.upsale,
            [subscriptionData.upsaleKey]:"paid"
          },
          upsalePaypalIDs: withUpsellPaypalId(userData, paypalId),
          upsaleIDs: [
            ...(userData.upsaleIDs || []),
            ...(Array.isArray(course_id) ? course_id : [course_id])
          ]
        }
        )
        await grantUpsellNow(userData, course_id, paypalId);
        navigate(nextSlug);
      }
    
  };

  const footerText = `By clicking ${button || 'Add to my plan'}, you agree to automatic subscription renewal. Your first month is ${currencySymbol + totalPrice}, then ${currencySymbol + oldPrice}/${period || 'month'}. You can cancel anytime by emailing contact@haaaaaaappy.com.`;

  return (
  <>
  {loading && <Spinner state={'opacity'}/>}
    <div className={styles.wrapper} ref={ref}>
      {discount && <div className={styles.discount}>{discount}</div>}
      {(totalPrice || oldPrice) && (
        <div className={styles.prices}>
          {totalPrice && <span>{currencySymbol + totalPrice}</span>}
          {oldPrice && <span className={styles.fullPrice}>{currencySymbol + oldPrice}</span>}
        </div>
      )}
      {typeTitle && <Title className={styles.typeTitle} dangerouslySetInnerHTML={{ __html:typeTitle }}/>}
      {typeText && <div className={styles.type}>{typeText}</div>}
      {message && <div className={styles.message}>{message}</div>}
      
      {sessionInfo?.subscription?.type ==='paypal' ? <div className={styles.paypal}>
        <div id={containerID} ref={paypalRef}></div>
        </div>:
        confirming ? (
          <UpsellConfirm
            className={styles.button}
            text={upsellConfirmText({ currencySymbol, firstPrice: totalPrice, fullPrice: oldPrice })}
            onConfirm={() => { setConfirming(false); handleSubmit(); }}
            onCancel={() => setConfirming(false)}
          />
        ) :
        <UpsaleButton
          onClick={() => (needsUpsellConfirm(type, sessionInfo?.subscription?.type) ? setConfirming(true) : handleSubmit())}
          className={cn(styles.button, buttonType === 'sticky' && styles.sticky)}
        >
          {button || "Add to my plan"}
        </UpsaleButton>
        }

      {type === 'subscription' && (
        <div className={styles.text}>{footerText}</div>
      )}
    </div>
  </>
    
  );
});
UpsaleCta.displayName = 'UpsaleCta';